module.exports = __webpack_public_path__ + "img/hr_login_blue.7224e311.png";